/* import __COLOCATED_TEMPLATE__ from './layout.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();